import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';

type ReceiptOptions = 'noReceipt' | 'print' | 'email' | 'sms';

type FlipAndTipReceiptToggleProps = {
    selected?: ReceiptOptions;
    onChange: (option: ReceiptOptions) => void;
};

const TEST_ID = {
  CTA: {
    noReceipt: `FlipAndTipReceiptToggle-noReceipt`,
    print: `FlipAndTipReceiptToggle-print`,
    email: `FlipAndTipReceiptToggle-email`,
    sms: `FlipAndTipReceiptToggle-sms`,
  }
};

const FlipAndTipReceiptToggle: FC<FlipAndTipReceiptToggleProps> = ({ selected, onChange }) => {
  const { t } = useTranslation();
  return (
    <Flex horizontal>
      <CTA
        data-testid={TEST_ID.CTA.noReceipt}
        key="noReceipt"
        variant="outlined"
        fullHeight
        padding="md"
        selected={selected === 'noReceipt'}
        onClick={() => onChange('noReceipt')}
      >
        <Copy variant="button-label" align="center" value={t(`flipAndTip.labels.noReceipt`)} />
      </CTA>
      <CTA
        data-testid={TEST_ID.CTA.print}
        key="print"
        variant="outlined"
        fullHeight
        padding="md"
        selected={selected === 'print'}
        onClick={() => onChange('print')}
      >
        <Copy variant="button-label" align="center" value={t(`flipAndTip.labels.printReceipt`)} />
      </CTA>
      <CTA
        data-testid={TEST_ID.CTA.email}
        key="email"
        variant="outlined"
        fullHeight
        padding="md"
        selected={selected === 'email'}
        onClick={() => onChange('email')}
      >
        <Copy variant="button-label" align="center" value={t(`flipAndTip.labels.emailReceipt`)} />
      </CTA>
      <CTA
        data-testid={TEST_ID.CTA.sms}
        key="sms"
        variant="outlined"
        fullHeight
        padding="md"
        selected={selected === 'sms'}
        onClick={() => onChange('sms')}
      >
        <Copy variant="button-label" align="center" value={t(`flipAndTip.labels.smsReceipt`)} />
      </CTA>
    </Flex>
  );
};

export { FlipAndTipReceiptToggle, ReceiptOptions, TEST_ID };
